import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Globe2, Tag, TrendingUp } from "lucide-react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

const icons = [Globe2, Tag, TrendingUp];

export const PartnershipModels = () => {
  const { t, path } = useLang();
  return (
    <section className="bg-[#F7F8F5] py-28 md:py-36" data-testid="home-partnership-models">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <Reveal className="mb-14">
          <p className="eyebrow-dark">{t.models.eyebrow}</p>
          <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-[#061A26]">{t.models.title}</h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {t.models.items.map((m, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={m.title} delay={i * 0.12} y={22}>
                <div
                  className="group h-full bg-white border border-black/8 p-9 md:p-11 hover:border-[#19C7C1]/50 hover:-translate-y-1 transition-[transform,border-color] duration-500"
                  data-testid={`partnership-model-${i}`}
                >
                  <Icon size={24} strokeWidth={1.5} className="text-[#19C7C1]" />
                  <h3 className="mt-6 text-lg md:text-xl font-semibold text-[#061A26]">{m.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{m.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.3} className="mt-12">
          <Link to={path("/partnerships")} className="btn-dark" data-testid="models-discuss-cta">
            {t.models.cta}
            <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
